import { FactoryProvider } from '@angular/core';
import { TranslationService } from '@lib/i18n/data-access';
import { DEFAULT_ERROR_MESSAGE_CONFIG, ErrorMessages } from '@platform-workspace/design-system';
import { LibPhoneNumberErrorType } from '@shared/utils/enums';
import {
  FileUploadExtensionValidatorCallbackParams,
  FileUploadSizeValidatorCallbackParams,
  MinMaxLengthValidatorCallbackParams,
  RangeValidatorCallbackParams,
  VALIDATION_MESSAGES,
  ValidatorsKeys,
} from '@shared/utils/validators';

export const provideDefaultErrorMessage = (): FactoryProvider => ({
  provide: DEFAULT_ERROR_MESSAGE_CONFIG,
  useFactory: (translationService: TranslationService): ErrorMessages => ({
    [ValidatorsKeys.Required]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Required]),
    [ValidatorsKeys.MaxLength]: ({ requiredLength }: MinMaxLengthValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.MaxLength], { value: requiredLength });
    },
    [ValidatorsKeys.MinLength]: ({ requiredLength }: MinMaxLengthValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.MinLength], { value: requiredLength });
    },
    [ValidatorsKeys.Email]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Email]),
    [ValidatorsKeys.LargeSize]: ({ requiredSize, format }: FileUploadSizeValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.LargeSize], { maxSize: requiredSize, format });
    },
    [ValidatorsKeys.Format]: ({ format }: FileUploadExtensionValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Format], { format: format.join(',') });
    },
    [ValidatorsKeys.UniqueName]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.UniqueName]),
    [ValidatorsKeys.Min]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Min]),
    [ValidatorsKeys.Max]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Max]),
    [ValidatorsKeys.ForbiddenSymbols]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.ForbiddenSymbols]),
    [ValidatorsKeys.Pattern]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Pattern]),
    [LibPhoneNumberErrorType.NotValid]: translationService.translate(VALIDATION_MESSAGES[LibPhoneNumberErrorType.NotValid]),
    [ValidatorsKeys.Range]: ({ min, max }: RangeValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Range], { min, max });
    },
    [ValidatorsKeys.BrandId]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.BrandId]),
  }),
  deps: [TranslationService],
});
